import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import { ProvisionsForLiabilitiesService } from './service/provisions-for-liabilities.service';

import * as CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
@Component({
  selector: 'app-provisions-for-liabilities',
  templateUrl: './provisions-for-liabilities.component.html',
  styleUrls: ['./provisions-for-liabilities.component.scss']
})
export class ProvisionsForLiabilitiesComponent implements OnInit {



  Total: number;
  isJump: any;
  CreateProvisionsForLiabilitiesFormGroup: FormGroup;
  NormalRoutng: boolean;
  showBubbledata: any;
  provisionsforliabilitiesid:any
  constructor(public FormBuilder: FormBuilder, public ProvisionsForLiabilitiesService: ProvisionsForLiabilitiesService, public Router: Router, public commonService: CommonService, private sidenav: SideNavService) {

  }


  ngOnInit(): void {
    debugger
    this.isJump = localStorage.getItem('isJump');
    this.CreateProvisionsForLiabilitiesForm();
    this.GetBorrowings();
    this.commonService.getNotesData();
 this.clearfield();
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.CreateProvisionsForLiabilitiesFormGroup.controls['APPeriodId'].value).subscribe((data) => {
      this.commonService.showBubble = data[0].ImportStatus
      if (this.commonService.showBubble) {
        this.sidenav.setShowBubble(true)
        this.GetBorrowings_LY()
      }
    })
    if (localStorage.getItem("SubmitStatus") == "true")
      this.CreateProvisionsForLiabilitiesFormGroup.disable()

  }

  CreateProvisionsForLiabilitiesForm() {
    this.CreateProvisionsForLiabilitiesFormGroup = this.FormBuilder.group({
      ProvisionsForLiabilitiesId: new FormControl(),
      ProvisionsForLiabilitiesGrossStart: new FormControl(),
      TransfersFromTheProfitAndLossAccount: new FormControl(),
      UtilisationOfProvision: new FormControl(),
      GrossEnd: new FormControl({ value: '', disabled: true }),

      AdditionalInformation: new FormControl(),
      CreatedBy: new FormControl(localStorage.getItem('LoginuserId')),
      CreatedDate: new FormControl(),
      ModifiedBy: new FormControl(),
      ModifiedDate: new FormControl(),
      APPeriodId: new FormControl(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)),

      MatchingData: new FormControl(),
    });
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        debugger
        var MatchingData = this.CreateProvisionsForLiabilitiesFormGroup.controls['MatchingData'].value;
        this.CreateProvisionsForLiabilitiesFormGroup.reset();
        this.CreateProvisionsForLiabilitiesFormGroup.controls['MatchingData'].setValue(MatchingData);
      }
    })
  }

  GetBorrowings() {
    debugger;
    this.ProvisionsForLiabilitiesService.GetOneProvisionsForLiabilities(this.CreateProvisionsForLiabilitiesFormGroup.controls['APPeriodId'].value).subscribe((data: any) => {
      debugger;
      this.CreateProvisionsForLiabilitiesFormGroup.patchValue(data);
      this.provisionsforliabilitiesid = data.ProvisionsForLiabilitiesId;
      this.CreateProvisionsForLiabilitiesFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
    })
  }

  GetBorrowings_LY() {
    debugger;
    this.ProvisionsForLiabilitiesService.GetOneProvisionsForLiabilities_LY(this.CreateProvisionsForLiabilitiesFormGroup.controls['APPeriodId'].value).subscribe((data: any) => {
      debugger;
      this.showBubbledata = data;
      this.CreateProvisionsForLiabilitiesFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
    })
  }

  On_Next() {
    debugger;
    if (this.On_NextBalancesheatValidaton()) {
      this.CreateProvisionsForLiabilitiesFormGroup.controls["APPeriodId"].setValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
      this.ProvisionsForLiabilitiesService.SaveProvisionsForLiabilities(this.CreateProvisionsForLiabilitiesFormGroup.getRawValue()).subscribe(data => {
        this.CreateProvisionsForLiabilitiesFormGroup.markAsPristine();
        if (this.NormalRoutng)
          return true;
        var nextPage;
        nextPage = this.commonService.getNextNoteSelection("Provisions for liabilities", this.commonService.NotesList)
        if (this.isJump == 'true')
          this.Router.navigate(['/notes'])
        else if (nextPage == 'provisionsforliabilities') {
          nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
          this.Router.navigate([nextPage]);
        }
        else {
          this.Router.navigate([nextPage]);
        }
      })
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }

  On_Back() {
    debugger;
    this.CreateProvisionsForLiabilitiesFormGroup.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.Router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Provisions for liabilities", this.commonService.NotesList)
      this.Router.navigate([backpage]);
    }
  }

  Calculations() {
    debugger;
    var total = +this.CreateProvisionsForLiabilitiesFormGroup.controls['ProvisionsForLiabilitiesGrossStart'].value + +this.CreateProvisionsForLiabilitiesFormGroup.controls['TransfersFromTheProfitAndLossAccount'].value
      - +this.CreateProvisionsForLiabilitiesFormGroup.controls['UtilisationOfProvision'].value;
    this.CreateProvisionsForLiabilitiesFormGroup.controls['GrossEnd'].setValue(total == 0 ? '' : total);
  }

  On_NextBalancesheatValidaton() {
    debugger; 
    if (+this.CreateProvisionsForLiabilitiesFormGroup.controls['GrossEnd'].value != Math.abs(+this.CreateProvisionsForLiabilitiesFormGroup.controls['MatchingData'].value)) {
      Swal.fire("Andica Accounts Production", "Provisions for liabilities at " + this.commonService.EndDate + " must tally with the Provisions for liabilities field value in the balance sheet for the year " + this.commonService.StartYear + ".", "warning")
      return false;
    }
    return true;
  }



  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.CreateProvisionsForLiabilitiesFormGroup.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          debugger;
          this.NormalRoutng = true;
          if (this.On_Next()) {
            return true;
          }
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.Router.navigate(['/business']);

  }

}
